const func = $target => {
	var $nav = $target.find('nav ul'),
		$active = $nav.find('.active'),
		$tooltip = $target.find('[data-toggle="tooltip"]'),
		$currency = $target.find('[data-toggle="dropdown"]');

	if ($active[0]) {
		$nav.animate(
			{
				scrollLeft: $active.offset().left - $(window).width() / 2 + $active.width() / 2
			},
			250,
			'swing'
		);
	}

	//$tooltip.tooltip(); - now init by app.js

	window.loader.key('enquire', function() {
		enquire.register('screen and (max-width: 767.98px)', {
			match: function() {
				$tooltip.tooltip('disable');
			},
			unmatch: function() {
				$tooltip.tooltip('enable');
			}
		});
	});

	$tooltip.on('show.bs.tooltip', function() {
		$currency.dropdown('hide');
	});
};

export default func;
